import { apiGet } from "./client";

export function getScenarioOutputRoot(scenarioId: number): Promise<any> {
  return apiGet<any>(`/modelscenario/${scenarioId}/output-root`);
}

export function getOutputModelDataChildren(
  modelDataId: number,
): Promise<any> {
  return apiGet<any>(`/output-modeldata/${modelDataId}/children`);
}
